import { render, staticRenderFns } from "./DocOtherForm.vue?vue&type=template&id=a300f286&lang=html&"
import script from "./DocOtherForm.vue?vue&type=script&lang=js&"
export * from "./DocOtherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports